import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import Logo from "@/components/Logo";

const BG = "https://images.unsplash.com/photo-1584897356466-858d9b6c53d1?auto=format&fit=crop&w=1600&h=900&q=80";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [agree, setAgree] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!agree) { setError("You must agree to the Terms & Conditions to continue."); return; }
    setError(""); setLoading(true);
    const res = await register(name, email, password);
    setLoading(false);
    if (res.ok) navigate("/");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center px-4">
      <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-ink/85" />
      <div className="relative z-10 w-full max-w-md bg-surface/90 backdrop-blur-xl border border-white/10 rounded-2xl p-8 animate-fade-up">
        <Logo size="lg" className="mb-6" />
        <h1 className="font-display text-3xl font-black mb-2">Create Account</h1>
        <p className="text-white/60 text-sm mb-6">Start streaming the best of Burmese cinema.</p>
        {error && <p data-testid="register-error" className="bg-brand/15 text-brand text-sm rounded-md px-3 py-2 mb-4">{error}</p>}
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="register-name" required value={name} onChange={(e) => setName(e.target.value)} placeholder="Full name" className="w-full bg-ink border border-white/10 rounded-md px-4 py-3 outline-none focus:ring-1 focus:ring-brand" />
          <input data-testid="register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="w-full bg-ink border border-white/10 rounded-md px-4 py-3 outline-none focus:ring-1 focus:ring-brand" />
          <input data-testid="register-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password (min 6 chars)" className="w-full bg-ink border border-white/10 rounded-md px-4 py-3 outline-none focus:ring-1 focus:ring-brand" />
          <label className="flex items-start gap-2 text-xs text-white/60">
            <input data-testid="register-agree" type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} className="mt-0.5 accent-brand w-4 h-4" />
            <span>
              I agree to the <Link to="/terms" className="text-gold hover:underline" target="_blank">Terms &amp; Conditions</Link> and <Link to="/privacy" className="text-gold hover:underline" target="_blank">Privacy Policy</Link>, including restrictions on copying, recording and redistribution of content, and I release Mandalay+ from related liability.
            </span>
          </label>
          <button data-testid="register-submit" disabled={loading || !agree} className="w-full bg-brand hover:bg-brand/90 transition-colors rounded-md font-semibold py-3 flex items-center justify-center gap-2 disabled:opacity-50">
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Create Account
          </button>
        </form>
        <p className="text-sm text-white/60 mt-4">Already have an account? <Link to="/login" data-testid="goto-login" className="text-white hover:text-gold">Sign in</Link></p>
      </div>
    </div>
  );
}
